<template>
  <section id="feed2">
    <feed2>
      <slot />
    </feed2>
  </section>
</template>

<script>
  export default {
    name: 'HomeAbout2',

    components: {
      Feed2: () => import('@/components/Feed2'),
    },
  }
</script>
